module.exports = __webpack_public_path__ + "media/files/terms-c5bec118a232d97e948df013a6687691.docx";